module.exports = __webpack_public_path__ + "9d1ccb46fb53a097e24c090384dbfaaa.png";